import { Types } from "../actionTypes";
import { networkStatus } from "../../constants";

export const initialState = {
  addMembersStatus: networkStatus.CLEAR,
  editMemberStatus: networkStatus.CLEAR,
  getMembersStatus: networkStatus.CLEAR,
  getMemberStatus: networkStatus.CLEAR,
  activeMemberCountStatus: networkStatus.CLEAR,
  members: null,
  activeMemberCount: null,
  totalMembers: null,
  totalPages: 1,
  memberToEdit: null,
};

//TODO: When this is converted to slice use adminSlice.js and put state, actions there.

const adminMembers = (state = initialState, action) => {
  switch (action.type) {
    case Types.CLEAR_ADD_MEMBERS_STATUS:
      return {
        ...state,
        addMembersStatus: networkStatus.CLEAR,
      };
    case Types.ADMIN_ADD_MEMBERS:
      return {
        ...state,
        addMembersStatus: networkStatus.IN_PROGRESS,
      };
    case Types.ADMIN_ADD_MEMBERS_SUCCESS:
      return {
        ...state,
        addMembersStatus: networkStatus.SUCCESS,
      };
    case Types.ADMIN_ADD_MEMBERS_FAILURE:
      return {
        ...state,
        addMembersStatus: networkStatus.ERROR_OTHER,
      };
    case Types.ADMIN_EDIT_MEMBER:
      return {
        ...state,
        editMemberStatus: networkStatus.IN_PROGRESS,
      };
    case Types.ADMIN_EDIT_MEMBER_SUCCESS:
      const members = [...state.members];

      for (let i = 0; i < members.length; i++) {
        if (members[i].member_key === action.payload.previousMemberKey) {
          members[i] = action.payload.member;
          break;
        }
      }

      return {
        ...state,
        editMemberStatus: networkStatus.SUCCESS,
        members,
      };
    case Types.ADMIN_EDIT_MEMBER_FAILURE:
      return {
        ...state,
        editMemberStatus: networkStatus.ERROR_OTHER,
      };
    case Types.CLEAR_EDIT_MEMBER_STATUS:
      return {
        ...state,
        editMemberStatus: networkStatus.CLEAR,
      };
    case Types.ADMIN_GET_MEMBERS:
      return {
        ...state,
        getMembersStatus: networkStatus.IN_PROGRESS,
      };
    case Types.ADMIN_GET_MEMBERS_SUCCESS:
      const { isSearching, mergeResponse } = action.payload;
      let newMembers;
      if (isSearching || mergeResponse) {
        newMembers = state.members
          ? [...state.members, ...action.payload.members]
          : action.payload.members;
      } else {
        newMembers = action.payload.members;
      }
      return {
        ...state,
        getMembersStatus: networkStatus.SUCCESS,
        members: newMembers,
        totalPages: action.payload.totalPages,
        totalMembers: action.payload.totalMembers,
      };
    case Types.ADMIN_GET_ACTIVE_MEMBER_COUNT:
      return {
        ...state,
        activeMemberCountStatus: networkStatus.IN_PROGRESS,
      };
    case Types.ADMIN_GET_ACTIVE_MEMBER_COUNT_SUCCESS:
      return {
        ...state,
        activeMemberCountStatus: networkStatus.SUCCESS,
        activeMemberCount: action.payload,
      };
    case Types.ADMIN_GET_ACTIVE_MEMBER_COUNT_FAILURE:
      return {
        ...state,
        activeMemberCountStatus: networkStatus.ERROR_OTHER,
      };
    case Types.ADMIN_CLEAR_MEMBERS:
      return {
        ...state,
        members: null,
      };
    case Types.ADMIN_GET_MEMBERS_FAILURE:
      return {
        ...state,
        getMembersStatus: networkStatus.ERROR_OTHER,
      };
    case Types.ADMIN_GET_MEMBER:
      return {
        ...state,
        getMemberStatus: networkStatus.IN_PROGRESS,
      };
    case Types.ADMIN_GET_MEMBER_SUCCESS:
      return {
        ...state,
        memberToEdit: action.response,
        getMemberStatus: networkStatus.SUCCESS,
      };
    case Types.ADMIN_GET_MEMBER_FAILURE:
      return {
        ...state,
        getMemberStatus: networkStatus.ERROR_OTHER,
      };
    case Types.CLEAR_GET_MEMBER_STATUS:
      return {
        ...state,
        getMemberStatus: networkStatus.CLEAR,
      };
    case Types.ADMIN_TOOL_UNAUTHORIZED:
      return {
        ...state,
        addMembersStatus: networkStatus.ERROR_UNAUTH,
        editMemberStatus: networkStatus.ERROR_UNAUTH,
        getMembersStatus: networkStatus.ERROR_UNAUTH,
      };
    default:
      return state;
  }
};

//selectors

export const getAddMembersStatus = (state) => state.addMembersStatus;
export const getAdminMembers = (state) => state.members;
export const getAdminMember = (state) => state.memberToEdit;
export const getEditMemberStatus = (state) => state.editMemberStatus;
export const getNumberPages = (state) => state.totalPages;
export const shareGetMembersStatus = (state) => state.getMembersStatus;
export const getGetMemberStatus = (state) => state.getMemberStatus;
export const getActiveMemberCountStatus = (state) => state.activeMemberCountStatus;
export const getActiveMemberCount = (state) => state.activeMemberCount;
export const getTotalMemberCount = (state) => state.totalMembers;
export default adminMembers; // the reducer
